import { Component } from '@angular/core';

@Component({
  selector: 'app-something-wrong',
  imports: [],
  templateUrl: './something-wrong.component.html',
  styleUrl: './something-wrong.component.css'
})
export class SomethingWrongComponent {

}
